import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './ArrowButton.themes';
type Props = {
  className?: string;
  color?: Colors;
  hasNoRtl?: boolean;
  isDisabled?: boolean;
  label?: string;
  onClick: (event?: React.SyntheticEvent | KeyboardEvent) => void;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
  rotation?: number;
  size?: number;
  theme?: keyof typeof themes;
};
export const ArrowButton = ({
  className,
  color,
  hasNoRtl,
  isDisabled,
  label,
  onClick,
  onMouseDown,
  onMouseUp,
  rotation = 0,
  theme = 'default',
  ...rest
}: Props) => {
  const { thRoot } = themes[theme]({
    color,
    isDisabled,
  });
  return (
    <button
      {...rest}
      aria-disabled={isDisabled}
      className={classnames(thRoot, className)}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      type="button"
    >
      <Icon hasRtl={!hasNoRtl} name={ICONS.ARROW_LEFT} rotation={rotation} width="1em" />
      {label && <span className="sr-only">{label}</span>}
    </button>
  );
};
